import { render, staticRenderFns } from "./PartnerIndex.vue?vue&type=template&id=26d96fea&scoped=true"
import script from "./PartnerIndex.vue?vue&type=script&lang=js"
export * from "./PartnerIndex.vue?vue&type=script&lang=js"
import style0 from "./PartnerIndex.vue?vue&type=style&index=0&id=26d96fea&prod&lang=less&scoped=true"
import style1 from "./PartnerIndex.vue?vue&type=style&index=1&id=26d96fea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d96fea",
  null
  
)

export default component.exports